import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';

import ListsAndImage from 'commonComponents/ListsAndImage/ListsAndImage';
import styles from './BiddingProcessSection.module.scss';

const BiddingProcessSection = ({ headers, summary, content, button, anchor }) => {
  return (
    <BaseSection
      { ...headers }
      button={ button }
      anchor={ anchor }
    >
      <ListsAndImage { ...summary } />
      { content && content.map(item => (
        <ImageAndText key={ item.title } { ...item } />
      )) }
    </BaseSection>
  );
};

const ImageAndText = ({ image, title, text }) => {
  return (
    <div className={ styles.ImageAndText }>
      <figure className={ styles.image }>
        <img src={ image } />
      </figure>
      <article className={ styles.text }>
        <h5>{ title }</h5>
        { text && text.map(paragraph => <p key={ paragraph }>{ paragraph }</p>) }
      </article>
    </div>
  );
};
  
export default BiddingProcessSection;
